import React, { memo } from 'react'
import { Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material'

const ActionMenu = ({ anchorEl, onClose, menuItems = [], menuId = 'action-menu' }) => {
  const isOpen = Boolean(anchorEl)

  const handleItemClick = (onClick) => {
    if (onClick) onClick()
    onClose()
  }

  return (
    <Menu
      id={menuId}
      anchorEl={anchorEl}
      open={isOpen}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      {menuItems.map(({ label, onClick, icon: Icon, disabled }, index) => (
        <MenuItem key={label || index} onClick={() => handleItemClick(onClick)} disabled={disabled}>
          {Icon && (
            <ListItemIcon>
              <Icon fontSize='small' />
            </ListItemIcon>
          )}
          <ListItemText primary={label} />
        </MenuItem>
      ))}
    </Menu>
  )
}

export default memo(ActionMenu)
